import Versus from "./Versus";
import MatchID from "./MatchID";
import Score from "./Score";
import Ticker from "./Ticker";
import FFStats from "./FFStats";
import Name from "./Name";
import POTM from "./POTM";
import Card from "./Card";
import Substitute from "./Substitute";
import FixturesResults from "./FixturesResults";
import Lineup from "./Lineup";
import Formation from "./Formation";
import Standings from "./Standings";
import PlayerStats from "./PlayerStats";
import ActionAreas from "./ActionAreas";
import ZonesOfControl from "./ZonesOfControl";
import TouchMap from "./TouchMap";
import PlayerTouchMap from "./TouchMap";
function ButtonFactory({
  component,
  game,
  previewGraphic,
  group,
  period,
  optaEvents,
  allOptaEvents,
  homeScorers,
  awayScorers,
  player,
  selectedSubPlayer,
}) {
  if (component.data.name === "MATCH_ID") {
    return (
      <MatchID
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        group={group}
      />
    );
  }
  if (component.data.name === "VERSUS") {
    return (
      <Versus
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        group={group}
        period={period}
      />
    );
  }
  if (component.data.name === "SCORE") {
    return (
      <Score
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        group={group}
        period={period}
        optaEvents={optaEvents}
        homeScorers={homeScorers}
        awayScorers={awayScorers}
      />
    );
  }
  if (
    component.data.name === "HOME_TEAM_TICKER" ||
    component.data.name === "AWAY_TEAM_TICKER"
  ) {
    return (
      <Ticker
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        group={group}
        period={period}
        allOptaEvents={allOptaEvents}
      />
    );
  }
  if (component.data.name === "FF_STATS") {
    return (
      <FFStats
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        homeScorers={homeScorers}
        awayScorers={awayScorers}
      />
    );
  }
  if (component.data.name === "NAME") {
    return (
      <Name
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        player={player}
      />
    );
  }
  if (component.data.name === "POTM") {
    return (
      <POTM
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        player={player}
      />
    );
  }
  if (component.data.name === "CARD") {
    return (
      <Card
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        player={player}
      />
    );
  }
  if (component.data.name === "SUBSTITUTE") {
    return (
      <Substitute
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        playerOn={selectedSubPlayer}
        playerOff={player}
      />
    );
  }
  if (component.data.name === "FIXTURES") {
    return (
      <FixturesResults
        component={component}
        game={game}
        previewGraphic={previewGraphic}
      />
    );
  }
  if (component.data.name === "LINEUP") {
    return (
      <Lineup
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        homeManager={game.home_manager}
        awayManager={game.away_manager}
      />
    );
  }
  if (component.data.name === "FORMATION") {
    return (
      <Formation
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        homeManager={game.home_manager}
        awayManager={game.away_manager}
      />
    );
  }
  if (component.data.name === "STANDINGS") {
    return (
      <Standings
        component={component}
        game={game}
        previewGraphic={previewGraphic}
      />
    );
  }
  if (component.data.name === "PLAYER_STATS") {
    return (
      <PlayerStats
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        player={player}
      />
    );
  }
  if (component.data.name === "ACTION_AREAS") {
    return (
      <ActionAreas
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        homeScorers={homeScorers}
        awayScorers={awayScorers}
        period={period}
      />
    );
  }
  if (component.data.name === "ZONES_OF_CONTROL") {
    return (
      <ZonesOfControl
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        homeScorers={homeScorers}
        awayScorers={awayScorers}
        period={period}
      />
    );
  }
  if (component.data.name === "PLAYER_TOUCH_MAP") {
    return (
      <PlayerTouchMap
        component={component}
        game={game}
        previewGraphic={previewGraphic}
        allOptaEvents={allOptaEvents}
        player={player}
      />
    );
  }
}
export default ButtonFactory;
